import { useCallback, useEffect, useState } from 'react';
import { describeSearchError, searchAll } from './searchApi';

export const MIN_QUERY_LENGTH = 2;
export const SEARCH_DEBOUNCE_MS = 250;

const IDLE_STATE = { status: 'idle', results: null, error: '' };

/** Запрос с задержкой; ответ на устаревший ввод отбрасывается. */
const useGlobalSearch = (rawQuery) => {
    const query = rawQuery.trim();
    const isSearchable = query.length >= MIN_QUERY_LENGTH;
    const [state, setState] = useState(IDLE_STATE);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        if (!isSearchable) {
            setState(IDLE_STATE);
            return undefined;
        }

        let cancelled = false;
        setState((current) => ({ ...current, status: 'loading', error: '' }));
        const timerId = window.setTimeout(async () => {
            try {
                const results = await searchAll(query);
                if (!cancelled) setState({ status: 'ready', results, error: '' });
            } catch (error) {
                if (!cancelled) setState({ status: 'error', results: null, error: describeSearchError(error) });
            }
        }, SEARCH_DEBOUNCE_MS);

        return () => {
            cancelled = true;
            window.clearTimeout(timerId);
        };
    }, [query, isSearchable, attempt]);

    const retry = useCallback(() => setAttempt((value) => value + 1), []);

    return { ...state, retry };
};

export default useGlobalSearch;
